<template>
  <v-container>
    <v-row align="center" justify="center">
      <h1>Your clinic's Patients</h1>
    </v-row>
    <v-row align="center" justify="center">
      <v-col md="12" sm="5" lg="12" col="12">
        <v-sheet class="mt-2 mb-2"
          ><v-btn large color="primary" @click="onProceed()">
            Add new patient
          </v-btn></v-sheet
        ></v-col
      >
    </v-row>

    <v-row justify="center" align="center">
      <v-col md="12" sm="5" lg="12" col="12">
        <h2>Recently added patient visits</h2>
        <table style="width: 100%" class="pa-5" density="compact">
          <tr style="text-align: left" class="recent-visits-header">
            <th>Owner's Last Name</th>
            <th>Patient's Name</th>
            <th>Submitted Date</th>
            <th>Breed</th>
          </tr>

          <tr
            v-for="(visit, index) in recentVisits"
            :key="visit.id"
            :class="{ highlight: index === 0 }"
          >
            <td>{{ visit.ownerLastName }}</td>
            <td>{{ visit.patientName }}</td>
            <td>{{ visit.dateCreated }}</td>
            <td>{{ visit.breed }}</td>
          </tr>
        </table>
      </v-col>
    </v-row>

    <v-row justify="center" align="center">
      <v-col md="12" sm="5" lg="12" col="12">
        <h2>Registered patients</h2>
        <h4 style="color: red">
          To view patient's visit(s) click the downward arrow in the left column
        </h4>
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Search / Edit existing patients"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="patients"
            :search="search"
            :items-per-page="itemsPerPage"
            :loading="loading"
            loading-text="Loading... Please wait"
            :sort-by="sortBy"
            :expanded.sync="itemExpanded"
            show-expand
            single-expand
            @item-expanded="onRowExpand"
            item-key="_id"
          >
            <template v-slot:[`item.dateCreated`]="{ item }">
              {{ formatdDate(item.dateCreated) }}</template
            >
            <template v-slot:[`item.edit`]="{ item }">
              <v-icon
                title="Edit patient"
                color="blue darken-2"
                @click="$router.push(`/home/manage-patient/${item._id}`)"
              >
                mdi-account-edit
              </v-icon></template
            >
            <template v-slot:[`item.manage-form`]="{ item }">
              <v-icon
                title="Add new visit"
                color="blue darken-2"
                @click="$router.push(`/home/create-new-form/${item._id}`)"
              >
                mdi-clipboard
              </v-icon></template
            >

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="padding: 15px">
                <div v-if="!item.forms">Loading..</div>
                <table
                  v-if="item && item.forms && item.forms.length > 0"
                  style="width: 70%"
                >
                  <caption style="text-align: start; margin-bottom: 7px">
                    Patient visit(s)
                  </caption>
                  <tr style="text-align: left">
                    <th>Visit date</th>
                    <th>Visit history</th>
                    <td></td>
                  </tr>
                  <tr v-for="i in item.forms" :key="i._id">
                    <td>{{ formatdDate(i.dateCreated) }}</td>
                    <td>{{ i.reason }}</td>
                    <td>
                      <v-icon
                        title="Review patient visit"
                        color="blue darken-2"
                        @click="
                          $router.push(
                            `/home/patient-form/${item._id}/${i._id}`
                          )
                        "
                      >
                        mdi-clipboard-edit
                      </v-icon>
                    </td>
                  </tr>
                </table>

                <span v-if="item && item.forms && item.forms.length == 0"
                  >no visits yet</span
                >
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import cookieWrapper from "../auth/cookieWrapper";
import dateTimeFormatter from "../util/dateTimeFormatter";

export default {
  name: "Patients",
  title: "HU Portal - Manage Patients",
  data() {
    return {
      itemsPerPage: 10,
      model: null,
      loading: true,

      search: "",
      headers: [
        {
          text: "Name",
          value: "name",
        },
        { text: "Date created", value: "dateCreated" },
        { text: "Species", value: "species.name" },
        { text: "Gender", value: "gender.name" },
        { text: "Visits", value: "visit_count" },
        { text: "", value: "edit", filterable: false },
        { text: "", value: "manage-form", filterable: false },
      ],

      patients: [],
      itemExpanded: [],
      sortBy: ["name"],
      recentVisits: [],
    };
  },
  async mounted() {
    let self = this;

    try {
      const token = cookieWrapper.getToken(self);

      let config = {
        method: "get",
        url: `/api/patient/all?clinicId=${self.$store.state.loggedInClinicId}&secret_token=${token}`,
        headers: {
          "Content-Type": "application/json",
        },
      };

      const result = await axios(config);

      //add forms fields. it will be filled on row expand in onRowExpand
      self.patients = result.data.map((item) => {
        return {
          forms: {},
          ...item,
        };
      });

      //load recent visits
      config = {
        method: "get",
        url: `/api/patient-form/recentVisitsByClinic?clinicId=${self.$store.state.loggedInClinicId}&secret_token=${token}`,
        headers: {
          "Content-Type": "application/json",
        },
      };

      self.recentVisits = (await axios(config)).data;

      //console.log(self.recentVisits);
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    edit(id) {
      console.log(id);
    },

    formatdDate(d) {
      //return dateTimeFormatter.formatDateTime(d);
      return dateTimeFormatter.formatWithMask(d, "YYYY-MM-DD hh:mm A");
    },

    async onRowExpand({ item, value }) {
      let self = this;

      if (value != true) {
        return;
      }

      const token = cookieWrapper.getToken(self);

      let config = {
        method: "get",
        url: `/api/patient-form/formsByPatient/${item._id}?secret_token=${token}`,
        headers: {
          "Content-Type": "application/json",
        },
      };

      const patient_forms = await axios(config);

      item.forms = patient_forms.data;
    },

    onProceed() {
      const answer = confirm(
        "Please confirm this is a New Patient registration and has not been previously entered into the portal. If this is not a new patient, find the patient in your 'Patients' list and add new visit."
      );

      if (answer) {
        this.$router.push(`/home/create-patient`);
      }
    },
  },
};
</script>

<style scoped>
.recent-visits-header th {
  background-color: rgb(207, 223, 223);
  padding: 5px;
  border-bottom: #353430 1px solid;
}

/* Style for all table rows to ensure a base font color */
tr {
  color: #333; /* Dark gray text */
}

td {
  padding-left: 10px;
  padding-top: 3px;
}

.highlight {
  background-color: #fff8dc;
  transition: background-color 0.6s ease;
}
</style>

